import { Button } from '@skupreme/shared/ui';

export type ManualShipActionsProps = {
  isDisabled?: boolean;
  isSaving?: boolean;
  onCancel: () => void;
};

export function ManualShipActions({
  isDisabled,
  isSaving,
  onCancel,
}: ManualShipActionsProps) {
  return (
    <div className="sk:flex sk:items-center sk:gap-2 sk:border-t sk:border-rule sk:pt-4">
      <Button
        type="submit"
        variant="primary"
        size="lg"
        className="sk:flex-1"
        isDisabled={isDisabled || isSaving}
      >
        {isSaving ? 'Saving' : 'Add tracking'}
      </Button>
      <Button type="button" variant="pill" size="lg" onPress={onCancel}>
        Cancel
      </Button>
    </div>
  );
}
